import { Component, OnDestroy, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'sc-modal',
  templateUrl: './modal.component.html',
})
export class ModalComponent implements OnInit, OnDestroy {

  @Output() overlayClick = new EventEmitter();

  ngOnInit() {
    document.body.style.overflow = 'hidden';
  }

  ngOnDestroy() {
    document.body.style.removeProperty('overflow');
  }

  onOverlayClick() {
    this.overlayClick.emit();
  }
}
